import { render, staticRenderFns } from "./BiCohortsFilter.vue?vue&type=template&id=75d8fbc8&scoped=true&"
import script from "./BiCohortsFilter.vue?vue&type=script&lang=js&"
export * from "./BiCohortsFilter.vue?vue&type=script&lang=js&"
import style0 from "./BiCohortsFilter.vue?vue&type=style&index=0&id=75d8fbc8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d8fbc8",
  null
  
)

export default component.exports